export default __webpack_public_path__ + "static/Manguito-8064b92633b2de847f4d8cf121db62fd.jpeg";